import { z } from 'zod';
import { TenantUtilizationExportQuerySchema } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider/tenant-utilization.routes.ts`. */
export const providerTenantUtilizationContract = {
    exportCsv: {
        method: 'GET',
        path: '/provider/tenant-utilization/export.csv',
        query: TenantUtilizationExportQuerySchema,
        response: z.unknown(),
        responseStyle: 'blob-attachment',
        attachmentFallbackFilename: 'tenant-utilization.csv',
        timeoutMs: 60000,
        errorMessage: 'Failed to download tenant utilization CSV',
    },
};
//# sourceMappingURL=provider-tenant-utilization.contract.js.map